import { TowerServiceStatus } from '@/types/device'

export const DEFAULT_TOWER_STATUS: TowerServiceStatus = 'initializing'

export const TOWER_SERVICE_STATUSES: TowerServiceStatus[] = [
  'initializing',
  'preparing',
  'downloading',
  'starting_up',
  'running',
  'degraded',
  'stopped',
  'failed'
]

export const TOWER_BUSY_STATUSES: TowerServiceStatus[] = [
  'preparing',
  'downloading',
  'starting_up'
]

export const TOWER_DEPLOY_REJECTED_STATE = 'deploy_rejected'
export const TOWER_UNINSTALLED_STATE = 'uninstalled'

export const TOWER_ERROR_CODES = [
  'missing_token',
  'invalid_environment',
  'invalid_registry',
  'confirmation_required',
  'missing_volume',
  'missing_path',
  'unknown_volume',
  'volume_not_found'
] as const

export type TowerErrorCode = (typeof TOWER_ERROR_CODES)[number]

export const isTowerBusyStatus = (status: TowerServiceStatus) => {
  return TOWER_BUSY_STATUSES.includes(status)
}

export const isKnownTowerStatus = (
  status: string
): status is TowerServiceStatus => {
  return TOWER_SERVICE_STATUSES.some((known) => known === status)
}

export const isTowerErrorCode = (error: string): error is TowerErrorCode => {
  return TOWER_ERROR_CODES.some((code) => code === error)
}
